export const faqData = [
  {
    title: 'O Portal de Negociação é seguro?',
    description:
      'Sim. A segurança dos seus dados é nossa prioridade. Por isso, utilizamos certificados de segurança e cumprimos todas as normas da Lei Geral de Proteção de Dados (LGPD).<br><br> Além disso, asseguramos total confidencialidade das informações que você nos fornece.',
  },
  {
    title:
      'Recebi uma mensagem de vocês por e-mail ou SMS, o que devo fazer agora?',
    description:
      'Quando você receber uma mensagem nossa, seja por E-mail, SMS ou WhatsApp, basta clicar no link para começar sua negociação. Todo o procedimento é online.<br><br> Tudo fácil e prático como você precisa!',
  },
  {
    title: 'Quanto tempo leva para o pagamento ser baixado?',
    description: 'A baixa acontece em até 5 dias úteis em nosso site.',
  },
  {
    title: 'O que devo fazer para remover meu nome do SPC/SERASA?',
    description:
      'Quando o pagamento é efetuado, a empresa credora deve encaminhar a informação às protetoras de crédito (Serasa, SPC etc.) em até 5 dias úteis para que a anotação negativa seja removida.<br><br> Para esclarecer qualquer outra dúvida sobre isso, recomendamos procurar diretamente a empresa credora. A legislação brasileira prevê que apenas quem registrou a negativação pode removê-la do CPF.',
  },
  {
    title: 'O que preciso fazer para emitir a segunda via do meu boleto?',
    description:
      'Caso tenha negociado pelo Portal, basta acessá-lo novamente para obter a segunda via do boleto.<br><br> Se o pagamento não for realizado até a data limite, o acordo será encerrado.<br><br> Não se preocupe, pois tudo que você já pagou será descontado da dívida original, e as próximas ofertas levam isso em conta. Ninguém fica prejudicado.',
  },
];
